// ACCORDION

class AccordionWrapper {
	constructor (accordionElement) {
		this.accordions = [...accordionElement.children].map(element => new Accordion(this, element))
	}

	openElement (element) {
		this.accordions.map(el => {
			if (el.element === element) el.open()
			else el.close()
		})
	}
}
class Accordion {
	constructor (accordionWrapper, element) {
		this.accordionWrapper = accordionWrapper
		this.element = element
		this.button = element.querySelector('.accordion-button')
		this.content = element.querySelector('.accordion-content')
		this.arrow =  this.button.querySelector('.arrow')
		this.accordion_text = document.querySelector('.accordion-content > p')
		this.isOpen = false
		this.registerListener()
	}

	registerListener () {
		this.button.addEventListener('click', () => this.toggle())
	}
	toggle () {
		if (this.isOpen) {
			this.close()
		} else {
			this.accordionWrapper.openElement(this.element)
		}
	}
	open () {
		this.isOpen = true
		this.render()
	}
	close () {
		this.isOpen = false
		this.render()
	}
	render () {
		if (this.isOpen) {
						const size  = this.accordion_text.getBoundingClientRect();
						console.log(size)
            this.content.style.maxHeight = size.bottom + 100 +"px";
						
						
			this.arrow.classList.add('open')
			this.content.classList.add('accordion-content--open');
		} else {

            this.content.style.maxHeight = null;
			this.arrow.classList.remove('open');
			this.content.classList.remove('accordion-content--open');
		}
    }   
}


document.addEventListener('DOMContentLoaded', () => {
	const el = document.querySelector('.accordion')
	if (el) {
		window.accordionWrapper = new AccordionWrapper(document.querySelector('.accordion-wrapper'))
	}
})


// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/modules/accordion.js